import { cn } from '@workspace/ui/lib/utils'
import type * as React from 'react'

interface InputProps extends React.ComponentProps<'input'> {
  startIcon?: React.ReactNode
  startIconClassName?: string
}

function Input({ className, type, startIcon, startIconClassName, ...props }: InputProps) {
  if (startIcon) {
    return (
      <div className="relative">
        <span
          className={cn(
            'pointer-events-none absolute left-3 top-1/2 flex size-3.5 -translate-y-1/2 items-center justify-center text-[#f97316] [&>svg]:size-full',
            startIconClassName
          )}
        >
          {startIcon}
        </span>
        <input
          type={type}
          data-slot="input"
          className={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-md border-none bg-input py-1 pr-3 pl-9 text-base text-foreground shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60 md:text-sm',
            'focus-visible:border-[rgb(249,115,22)] focus-visible:ring-[rgb(249,115,22)]/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            className
          )}
          {...props}
        />
      </div>
    )
  }

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-md border-none bg-input px-3 py-1 text-base text-foreground shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60 md:text-sm',
        'focus-visible:border-[rgb(249,115,22)] focus-visible:ring-[rgb(249,115,22)]/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  )
}

export { Input }
